import * as React from 'react'

import { useTimelineData } from '../context/DataContext'
import { PlaceBlock } from '../blocks/PlaceBlock'
import { LayerWrapper } from './LayerWrapper'
import { LayerProps } from './types'

const PlacesLayer: React.FC<LayerProps> = ({ zIndex }) => {
  const { places } = useTimelineData()

  return (
    <LayerWrapper zIndex={zIndex}>
      {places.map((item, index) => (
        <PlaceBlock key={index} place={item} index={index} />
      ))}
    </LayerWrapper>
  )
}

export default PlacesLayer
